module.exports = "img/button-text-bulleted-list-on.781075e.svg";